import type { SxProps, Theme } from '@mui/material';

interface IGetErrorMessageComponentSx {
  errorMessageSx?: SxProps<Theme>;
}

export const getErrorMessageComponentSx = ({
  errorMessageSx,
}: IGetErrorMessageComponentSx): SxProps<Theme> => ({
  fontSize: '0.875em',
  margin: '0.25rem 0.875rem 0',
  color: (theme) => theme.palette.error.main,
  ...errorMessageSx,
});
